import { Component, inject } from '@angular/core';
import { CategoryService } from '../../../service/category.service';
import { Category } from '../../../interfaces/categoryInterface';
import { MatTree } from '@angular/material/tree';
import { MatDialog } from '@angular/material/dialog';
import { CategoryCreateEditComponent } from './category-create-edit/category-create-edit.component';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { GenericStreamsService } from '../../../service/generic-streams.service';

@Component({
    selector: 'app-category-overview',
    standalone: false,

    templateUrl: './category-overview.component.html',
    styleUrl: './category-overview.component.scss'
})
export class CategoryOverviewComponent {
    categories?: any;
    categoriesStructure: Record<string, any>[] = [];
    structuredCategories: any[] = [];
    showCategoryCreate = false;
    parentId = '';
    allStreams: any[] = [];

    streamOrder: any[] = [];

    protected streamService = inject(GenericStreamsService)

    constructor(
        private categoryService: CategoryService,
        private dialog: MatDialog
    ) { }

    getStreamsByCatId(categoryId: string): any[] {
        console.log(categoryId)
        return this.allStreams.filter(stream => stream.categoryId.includes(categoryId));
    }

    async ngOnInit() {
        await this.categoryService.getCategories().then((data) => this.categories = data)
        const streamData = await this.streamService.getStreamCategoryMatch();
        if (streamData !== false) {
            this.allStreams = streamData;
        }
        this.buildCategoryTree();

        const result = await this.streamService.getAllStreamOrder();
        if (result !== false) {
            this.streamOrder = result;
            // console.log("Order", result)
        }
    }

    buildCategoryTree() {
        const categoryMap = new Map<string, any>();

        this.categories.forEach((cat: Category) => {

            categoryMap.set(cat.id, { ...cat, children: [] });
        })
        this.categories.forEach((cat: Category) => {
            if (cat.parentId === null) {
                this.structuredCategories.push(categoryMap.get(cat.id));
            } else {
                const parent = categoryMap.get(cat.parentId);
                if (parent) {
                    parent.children.push(categoryMap.get(cat.id));
                }
            }
        });
    }

    async createCategory(id?: string) {
        if (id) {
            this.parentId = id;
        }
        let dia = this.dialog.open(CategoryCreateEditComponent, {
            data: { category: { parentId: id } },
            width: '80%',
            height: '80%',
            panelClass: 'category-modal'
        })

        dia.afterClosed().subscribe(async (result) => {
            if (result == true) {
                this.parentId = "";
                await this.categoryService.getCategories().then((data) => this.categories = data);
                this.structuredCategories = [];
                this.buildCategoryTree();
            }
        })
    }

    async editCategory(category: any) {
        let dia = this.dialog.open(CategoryCreateEditComponent, {
            data: { category: category },
            width: '80%',
            height: '80%',
            panelClass: 'category-modal'
        })

        dia.afterClosed().subscribe(async (result) => {
            if (result == true) {
                await this.categoryService.getCategories().then((data) => this.categories = data);
                this.structuredCategories = [];
                this.buildCategoryTree();
            }
        })
    }

    async deleteCategory(id: any) {
        let i = confirm("Are you sure you want to delete this category?");
        if (!i) return;
        await this.categoryService.deleteCategory(id);
        await this.categoryService.getCategories().then((data) => this.categories = data);
        this.structuredCategories = [];
        this.buildCategoryTree();
    }

    closeCreateCategory() {
        this.parentId = '';
        this.showCategoryCreate = false;
    }

    childrenAccessor = (node: Category) => node.children ?? [];

    hasChild = (_: number, node: Category) => !!node.children && node.children.length > 0;

    async drop(event: any) {
        moveItemInArray(this.structuredCategories, event.previousIndex, event.currentIndex);
        let updatedOrders = this.structuredCategories.map((item, index) => ({
            id: item["id"],
            orderNr: index + 1,
        }));
        this.categoryService.updateOrderNumbers({ orderNumbers: updatedOrders });
    }
}
